import { render, staticRenderFns } from "./AddSalesPaymentPage.vue?vue&type=template&id=4fb664ae"
import script from "./AddSalesPaymentPage.vue?vue&type=script&lang=js"
export * from "./AddSalesPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports